{
  "v": "5.9.0",
  "fr": 25,
  "ip": 0,
  "op": 87,
  "w": 1000,
  "h": 1000,
  "nm": "See",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 3,
      "nm": "Null 3",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 0, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [500, 550, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [50, 100, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.704, 0.704, 0.704], "y": [1, 1, 1] },
              "o": { "x": [0.187, 0.187, 0.187], "y": [0, 0, 0] },
              "t": 0,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.145, 0.2, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.618, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 13,
              "s": [111, 114, 100]
            },
            {
              "i": { "x": [0.36, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.775, 0.745, 0.333], "y": [0, 0, 0] },
              "t": 38,
              "s": [107, 110, 100]
            },
            { "t": 68, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "eyes Outlines 2",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 0,
              "s": [46, 134, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.411, "y": 1 },
              "o": { "x": 0.618, "y": 0 },
              "t": 13,
              "s": [46, 134, 0],
              "to": [0, 15, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.36, "y": 1 },
              "o": { "x": 0.775, "y": 0 },
              "t": 38.652,
              "s": [46, 224, 0],
              "to": [0, 0, 0],
              "ti": [0, 15, 0]
            },
            { "t": 69, "s": [46, 134, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [30, 12, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [1211, 1214, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [3.554, 0],
                    [0, -6.467],
                    [-6.247, 0],
                    [0, 6.47],
                    [0.703, 1.527]
                  ],
                  "o": [
                    [-2.078, -2.661],
                    [-6.247, 0],
                    [0, 6.47],
                    [6.245, 0],
                    [0, -1.798],
                    [0, 0]
                  ],
                  "v": [
                    [8.807, -7.367],
                    [0, -11.73],
                    [-11.328, -0.001],
                    [0, 11.73],
                    [11.328, -0.001],
                    [10.23, -5.031]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.143, 0],
                    [0, 5.329],
                    [-5.145, 0],
                    [0, -5.326]
                  ],
                  "o": [
                    [-5.145, 0],
                    [0, -5.326],
                    [5.143, 0],
                    [0, 5.329]
                  ],
                  "v": [
                    [0.087, 9.66],
                    [-9.241, -0.001],
                    [0.087, -9.661],
                    [9.415, -0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 2",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.287, "y": 1 },
                    "o": { "x": 0.514, "y": 0 },
                    "t": 0,
                    "s": [48.5, 10.732],
                    "to": [0, -0.639],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 13,
                    "s": [48.5, 3.732],
                    "to": [0, 0],
                    "ti": [0, -1.167]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 38,
                    "s": [48.5, 10.732],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 68, "s": [48.5, 10.732] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [4.525, 0],
                    [0, -4.689],
                    [-4.525, 0],
                    [0, 4.685]
                  ],
                  "o": [
                    [-4.525, 0],
                    [0, 4.685],
                    [4.525, 0],
                    [0, -4.689]
                  ],
                  "v": [
                    [0, -8.501],
                    [-8.208, 0.001],
                    [0, 8.501],
                    [8.208, 0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.287, "y": 1 },
                    "o": { "x": 0.514, "y": 0 },
                    "t": 0,
                    "s": [11.328, 10.731],
                    "to": [0, -0.639],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 13,
                    "s": [11.328, 3.731],
                    "to": [0, 0],
                    "ti": [0, -1.167]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 38.652,
                    "s": [11.328, 10.731],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 69, "s": [11.328, 10.731] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.48, 0.48], "y": [1.014, 1.014] },
                    "o": { "x": [0.618, 0.618], "y": [0, 0] },
                    "t": 13,
                    "s": [100, 100]
                  },
                  {
                    "i": { "x": [0.332, 0.332], "y": [1, 1] },
                    "o": { "x": [0.719, 0.719], "y": [0, 0] },
                    "t": 38,
                    "s": [63, 63]
                  },
                  { "t": 64.65234375, "s": [100, 100] }
                ],
                "ix": 3
              },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [6.247, 0],
                    [0, -6.47],
                    [-6.247, 0],
                    [0, 6.469]
                  ],
                  "o": [
                    [-6.247, 0],
                    [0, 6.469],
                    [6.247, 0],
                    [0, -6.47]
                  ],
                  "v": [
                    [0, -11.732],
                    [-11.328, 0],
                    [0, 11.732],
                    [11.328, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.143, 0],
                    [0, 5.326],
                    [-5.143, 0],
                    [0, -5.327]
                  ],
                  "o": [
                    [-5.143, 0],
                    [0, -5.327],
                    [5.143, 0],
                    [0, 5.326]
                  ],
                  "v": [
                    [0, 9.661],
                    [-9.328, 0],
                    [0, -9.661],
                    [9.328, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 2",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.287, "y": 1 },
                    "o": { "x": 0.514, "y": 0 },
                    "t": 0,
                    "s": [11.328, 10.732],
                    "to": [0, -0.639],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 13,
                    "s": [11.328, 3.732],
                    "to": [0, 0],
                    "ti": [0, -1.167]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 38.652,
                    "s": [11.328, 10.732],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 69, "s": [11.328, 10.732] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [4.525, 0],
                    [0, -4.689],
                    [-4.525, 0],
                    [0, 4.685]
                  ],
                  "o": [
                    [-4.525, 0],
                    [0, 4.685],
                    [4.525, 0],
                    [0, -4.689]
                  ],
                  "v": [
                    [0, -8.501],
                    [-8.208, 0.001],
                    [0, 8.501],
                    [8.208, 0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.287, "y": 1 },
                    "o": { "x": 0.514, "y": 0 },
                    "t": 0,
                    "s": [48.587, 10.731],
                    "to": [0, -0.639],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 13,
                    "s": [48.587, 3.731],
                    "to": [0, 0],
                    "ti": [0, -1.167]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 38.652,
                    "s": [48.587, 10.731],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 69, "s": [48.587, 10.731] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3,
                "x": "var $bm_rt;\n$bm_rt = content('Group 2').transform.scale;"
              },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 2, "ix": 5 },
          "lc": 1,
          "lj": 1,
          "ml": 1,
          "bm": 0,
          "nm": "Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "eyes Outlines",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 0,
          "k": [46, 134, 0],
          "ix": 2,
          "l": 2,
          "x": "var $bm_rt;\n$bm_rt = thisComp.layer('eyes Outlines 2').transform.position;"
        },
        "a": { "a": 0, "k": [30, 12, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [1211, 1214, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.498, "y": 0 },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.929, -1.272],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.947, -1.309],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [25.296, 5.768],
                          [17.871, -6.413],
                          [12.602, -9.38],
                          [12.559, -9.38],
                          [6.697, -6.374],
                          [4.457, -3.566],
                          [3.759, -3.426],
                          [-3.684, -3.436],
                          [-4.415, -3.583],
                          [-6.511, -6.404],
                          [-11.786, -9.38],
                          [-11.83, -9.38],
                          [-17.668, -6.404],
                          [-25.295, 5.826],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 4,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.614, -1.506],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.662, -1.467],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [23.397, 5.606],
                          [17.918, -5.352],
                          [12.438, -8.319],
                          [12.395, -8.319],
                          [6.533, -5.314],
                          [4.293, -2.506],
                          [3.595, -2.366],
                          [-3.848, -2.375],
                          [-4.579, -2.522],
                          [-6.675, -5.344],
                          [-11.95, -8.319],
                          [-11.994, -8.319],
                          [-17.799, -5.341],
                          [-23.585, 5.74],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 6,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.173, -1.834],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.265, -1.687],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [23.507, 5.438],
                          [17.984, -3.869],
                          [12.21, -6.837],
                          [12.167, -6.837],
                          [6.305, -3.832],
                          [4.065, -1.024],
                          [3.367, -0.884],
                          [-4.076, -0.893],
                          [-4.807, -1.04],
                          [-6.903, -3.862],
                          [-12.178, -6.837],
                          [-12.222, -6.837],
                          [-17.982, -3.855],
                          [-23.609, 5.525],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.25, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 8,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-0.869, -2.06],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [0.991, -1.839],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [22.799, 3.804],
                          [18.029, -2.848],
                          [12.053, -5.817],
                          [12.01, -5.817],
                          [6.148, -2.812],
                          [3.908, -0.004],
                          [3.21, 0.136],
                          [-4.233, 0.127],
                          [-4.964, -0.02],
                          [-7.06, -2.842],
                          [-12.335, -5.817],
                          [-12.379, -5.817],
                          [-18.108, -2.832],
                          [-23.175, 4.192],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.618, "y": 0 },
                    "t": 13,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-0.64, -2.23],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [0.784, -1.954],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [21.79, 5.787],
                          [18.064, -2.077],
                          [11.935, -5.046],
                          [11.892, -5.046],
                          [6.03, -2.041],
                          [3.79, 0.767],
                          [3.092, 0.907],
                          [-4.351, 0.898],
                          [-5.082, 0.751],
                          [-7.178, -2.071],
                          [-12.453, -5.046],
                          [-12.497, -5.046],
                          [-18.203, -2.059],
                          [-22.253, 5.818],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 25,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.6, -1.517],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.65, -1.474],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [25.854, 8.936],
                          [18.003, -15.129],
                          [12.515, -18.096],
                          [12.472, -18.096],
                          [6.61, -15.091],
                          [4.37, -12.283],
                          [3.672, -12.143],
                          [-3.771, -12.152],
                          [-4.502, -12.299],
                          [-6.598, -15.121],
                          [-11.873, -18.096],
                          [-11.917, -18.096],
                          [-17.722, -15.118],
                          [-25.566, 7.913],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.145, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 28,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.79, -1.375],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.821, -1.379],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [26.888, 9.56],
                          [17.991, -17.717],
                          [12.63, -20.683],
                          [12.587, -20.683],
                          [6.725, -17.678],
                          [4.485, -14.87],
                          [3.786, -14.73],
                          [-3.657, -14.739],
                          [-4.388, -14.886],
                          [-6.484, -17.708],
                          [-11.758, -20.683],
                          [-11.803, -20.683],
                          [-17.626, -17.707],
                          [-26.451, 8.328],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.36, "y": 1 },
                    "o": { "x": 0.775, "y": 0 },
                    "t": 37,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.929, -1.272],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.947, -1.309],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [28.414, 10.017],
                          [17.983, -19.61],
                          [12.714, -22.576],
                          [12.671, -22.576],
                          [6.809, -19.571],
                          [4.569, -16.763],
                          [3.871, -16.623],
                          [-3.572, -16.632],
                          [-4.303, -16.779],
                          [-6.399, -19.601],
                          [-11.674, -22.576],
                          [-11.718, -22.576],
                          [-17.556, -19.601],
                          [-27.868, 8.632],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 69,
                    "s": [
                      {
                        "i": [
                          [-2.691, -2.994],
                          [-4.263, 0],
                          [-1.929, -1.272],
                          [0, 0],
                          [1.876, 0.016],
                          [0, 0],
                          [0.026, -0.03],
                          [0, 0],
                          [0.234, 0.133],
                          [0.144, -0.09],
                          [0.173, 0.234],
                          [0, 0],
                          [1.884, 0.016],
                          [0, 0],
                          [0.275, -0.308],
                          [0, 0],
                          [-2.487, 0],
                          [-2.264, -3.219],
                          [-4.337, 0.08]
                        ],
                        "o": [
                          [2.245, -3.393],
                          [2.45, 0],
                          [0, 0],
                          [-1.621, -1.952],
                          [0, 0],
                          [-3.265, 0],
                          [0, 0],
                          [-0.17, 0.213],
                          [-3.839, -2.161],
                          [-0.244, 0.147],
                          [0, 0],
                          [-1.609, -1.951],
                          [0, 0],
                          [-3.095, 0],
                          [0, 0],
                          [1.947, -1.309],
                          [4.132, 0],
                          [0.739, -0.824],
                          [3.032, -0.046]
                        ],
                        "v": [
                          [8.355, 9.38],
                          [18.631, 3.755],
                          [25.296, 5.768],
                          [17.871, -6.413],
                          [12.602, -9.38],
                          [12.559, -9.38],
                          [6.697, -6.374],
                          [4.457, -3.566],
                          [3.759, -3.426],
                          [-3.684, -3.436],
                          [-4.415, -3.583],
                          [-6.511, -6.404],
                          [-11.786, -9.38],
                          [-11.83, -9.38],
                          [-17.668, -6.404],
                          [-25.295, 5.826],
                          [-18.543, 3.755],
                          [-8.48, 9.07],
                          [-0.261, 4.947]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [29.844, -5.039], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.192, 0.667], "y": [1, 1] },
                    "o": { "x": [0.333, 0.333], "y": [0, 0] },
                    "t": 0,
                    "s": [100, 100]
                  },
                  {
                    "i": { "x": [0.591, 0.703], "y": [1, 1] },
                    "o": { "x": [0.218, 0.185], "y": [0, 0] },
                    "t": 13,
                    "s": [125, 100]
                  },
                  { "t": 37, "s": [100, 100] }
                ],
                "ix": 3
              },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [3.554, 0],
                    [0, -6.467],
                    [-6.247, 0],
                    [0, 6.47],
                    [0.703, 1.527]
                  ],
                  "o": [
                    [-2.078, -2.661],
                    [-6.247, 0],
                    [0, 6.47],
                    [6.245, 0],
                    [0, -1.798],
                    [0, 0]
                  ],
                  "v": [
                    [8.807, -7.367],
                    [0, -11.73],
                    [-11.328, -0.001],
                    [0, 11.73],
                    [11.328, -0.001],
                    [10.23, -5.031]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.143, 0],
                    [0, 5.329],
                    [-5.145, 0],
                    [0, -5.326]
                  ],
                  "o": [
                    [-5.145, 0],
                    [0, -5.326],
                    [5.143, 0],
                    [0, 5.329]
                  ],
                  "v": [
                    [0.087, 9.66],
                    [-9.241, -0.001],
                    [0.087, -9.661],
                    [9.415, -0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 2",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 0,
                    "s": [48.5, 11.732],
                    "to": [0, -1.333],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 10.392,
                    "s": [48.5, 3.732],
                    "to": [0, 0],
                    "ti": [0, -1.333]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 34.392,
                    "s": [48.5, 11.732],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 63, "s": [48.5, 11.732] }
                ],
                "ix": 2,
                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('eyes Outlines 2').content('Group 1').transform.position;"
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [4.525, 0],
                    [0, -4.689],
                    [-4.525, 0],
                    [0, 4.685]
                  ],
                  "o": [
                    [-4.525, 0],
                    [0, 4.685],
                    [4.525, 0],
                    [0, -4.689]
                  ],
                  "v": [
                    [0, -8.501],
                    [-8.208, 0.001],
                    [0, 8.501],
                    [8.208, 0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 0,
                    "s": [11.328, 11.731],
                    "to": [0, -1.333],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 10.392,
                    "s": [11.328, 3.731],
                    "to": [0, 0],
                    "ti": [0, -1.333]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 34.392,
                    "s": [11.328, 11.731],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 63, "s": [11.328, 11.731] }
                ],
                "ix": 2,
                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('eyes Outlines 2').content('Group 2').transform.position;"
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [6.247, 0],
                    [0, -6.47],
                    [-6.247, 0],
                    [0, 6.469]
                  ],
                  "o": [
                    [-6.247, 0],
                    [0, 6.469],
                    [6.247, 0],
                    [0, -6.47]
                  ],
                  "v": [
                    [0, -11.732],
                    [-11.328, 0],
                    [0, 11.732],
                    [11.328, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.143, 0],
                    [0, 5.326],
                    [-5.143, 0],
                    [0, -5.327]
                  ],
                  "o": [
                    [-5.143, 0],
                    [0, -5.327],
                    [5.143, 0],
                    [0, 5.326]
                  ],
                  "v": [
                    [0, 9.661],
                    [-9.328, 0],
                    [0, -9.661],
                    [9.328, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 2",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 0,
                    "s": [11.328, 11.732],
                    "to": [0, -1.333],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 10.392,
                    "s": [11.328, 3.732],
                    "to": [0, 0],
                    "ti": [0, -1.333]
                  },
                  {
                    "i": { "x": 0, "y": 0 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 34.392,
                    "s": [11.328, 11.732],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 63, "s": [11.328, 11.732] }
                ],
                "ix": 2,
                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('eyes Outlines 2').content('Group 3').transform.position;"
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [4.525, 0],
                    [0, -4.689],
                    [-4.525, 0],
                    [0, 4.685]
                  ],
                  "o": [
                    [-4.525, 0],
                    [0, 4.685],
                    [4.525, 0],
                    [0, -4.689]
                  ],
                  "v": [
                    [0, -8.501],
                    [-8.208, 0.001],
                    [0, 8.501],
                    [8.208, 0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.176470588235, 0.356862745098, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 10.392,
                    "s": [48.587, 3.731],
                    "to": [0, 1.333],
                    "ti": [0, -1.333]
                  },
                  { "t": 34.3916015625, "s": [48.587, 11.731] }
                ],
                "ix": 2,
                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('eyes Outlines 2').content('Group 4').transform.position;"
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 2, "ix": 5 },
          "lc": 1,
          "lj": 1,
          "ml": 6,
          "bm": 0,
          "nm": "Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [0, 0.176483154297, 0.356872558594, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 7, "ix": 5 },
          "lc": 3,
          "lj": 2,
          "bm": 0,
          "nm": "Stroke 2",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
